import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

import { Observable } from 'rxjs';

import {  } from '../state-management';

@Injectable()
export class MetadataService{
  metadataUrl = 'api/metadata/';
  httpOptions = {
    headers: new HttpHeaders({
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache'
    })
  };

  constructor(
    private httpClient: HttpClient
  ) { }

  getMetadata(dataNames: string): any {
    return this.httpClient.get(this.metadataUrl + 'getMeta/' + encodeURIComponent(dataNames), this.httpOptions);
  }

  getDataNames(featureLayerId: string): any{
    return this.httpClient.get(this.metadataUrl + 'getDataNames/' + featureLayerId, this.httpOptions);
  }
}
